export default {
      id: "milestones-usage",
      viewBox: "0 0 67 71",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#milestones",
      toString: function () {
        return this.url;
      }
    }